import { useSelector } from 'react-redux'

import { selectAppName } from 'root-redux/selects/common'
import { selectUserCountry } from 'root-redux/selects/user'

import { US_COUNTRY_CODE, US_GEO_RETENTION_FLOW_APPS } from 'root-constants'

export const useIsUsGeoRetentionFlow = (): boolean => {
  const appName = useSelector(selectAppName)
  const country = useSelector(selectUserCountry)

  return (
    US_GEO_RETENTION_FLOW_APPS.includes(appName) &&
    country.toUpperCase() === US_COUNTRY_CODE
  )
}
